<template>
  <div v-if="appointment && carId">
    <tab-title
      :car-id="appointment.car.id"
      text="破損" />
    <v-alert
      v-model="error"
      type="error"
      class="mb-3"
      outline
    >未入力の必須項目あり</v-alert>
    <v-form
      v-if="carId"
      ref="form">
      <span data-label-scroll="LEFT_FRONT" />
      <span data-label-scroll="LEFT_REAR" />
      <span data-label-scroll="RIGHT_FRONT" />
      <span data-label-scroll="RIGHT_REAR" />
      <cp-damages
        :car-id="carId"
        :types="schemeTypes"
        :photo-selection="photoSelection"
        responsive
        client-arrived
        @update="checkErrors"
        @ready="checkErrors"
      />
    </v-form>
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="attention#top">次へ</v-btn>
  </div>
</template>

<script>
import PhotoSelection from '../../components/elements/PhotoSelection';
import {
  getCarWith,
} from '../../queries';

export default {
  components: { PhotoSelection },
  apollo: {
    appointment: {
      query: getCarWith(),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result({ data }) {
        this.carId = data.appointment.car.id;
      },
    },
  },
  data() {
    return {
      error: false,
      schemeTypes: [
        'EXTERIOR',
        'INTERIOR',
        'EXTERIOR_ADDITIONAL',
        'INTERIOR_ADDITIONAL',
      ],
      carId: null,
      photoSelection: PhotoSelection,
    };
  },
  methods: {
    checkErrors(params) {
      this.error = !params.checked;
      this.refreshRemainingFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/DamageSchemeTab.vue